import { createColumnHelper } from '@tanstack/react-table';

import { Credential } from '../../../types';

export const columnHelper = createColumnHelper<Credential>();
